import moment from "moment";

export function formatDate(date) {
  if (!date) return "—";
  return moment(date).utcOffset(8).format("dddd, MMMM D, YYYY h:mm A");
}